module.exports = __webpack_public_path__ + "img/email-no.66247118.png";